import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { HistoryView } from "@/modules/chat/components/HistoryView";
import { DeleteSessionDialog } from "@/modules/chat/components/DeleteSessionDialog";
import { useSessions } from "@/modules/chat/hooks/use-sessions";

export const Route = createFileRoute("/_app/history")({
  component: HistoryRoute,
});

function HistoryRoute() {
  const { selectSession, deleteSession } = useSessions();
  const [deleteTarget, setDeleteTarget] = useState<string | null>(null);

  return (
    <>
      <HistoryView
        onOpenSession={selectSession}
        onDeleteSession={setDeleteTarget}
      />
      <DeleteSessionDialog
        open={deleteTarget !== null}
        onCancel={() => setDeleteTarget(null)}
        onConfirm={() => {
          if (deleteTarget) deleteSession(deleteTarget);
          setDeleteTarget(null);
        }}
      />
    </>
  );
}
